export default {
  placeholder: 'Search restaurant...',
};
